import { useEffect, useState } from 'react'

export const useWindow = () => {
  const [currentWindow, setCurrentWindow] = useState(window)

  useEffect(() => {
    const handleResize = () => {
      setCurrentWindow(window)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return currentWindow
}
